export function getDebugParams() {
    const urlParams = new URLSearchParams(window.location.search);

    if (process.env.NODE_ENV === 'production') {
        return {};
    }

    try {
        const decoded = decodeURIComponent(urlParams.get('ext') || '');

        return JSON.parse(decoded);
    } catch (err) {
        return {};
    }
}
